import { TranslationYupMessages, YupMessages } from "../interfaces/yupMessages";

export const messages: TranslationYupMessages = {
  [YupMessages.mixedDefault]: "Campo inválido",
  [YupMessages.mixedRequired]: "Campo obrigatório",
  [YupMessages.mixedOneOf]:
    "Campo deve ser um dos seguintes valores: {{values}}",
  [YupMessages.mixedNotOneOf]:
    "Campo não deve ser um dos seguintes valores: {{values}}",
  [YupMessages.mixedNotType]: "Campo obrigatório",

  [YupMessages.stringLength]:
    "O campo deve ter exatamente {{length}} caracteres",
  [YupMessages.stringMin]: "O campo deve ter pelo menos {{min}} caracteres",
  [YupMessages.stringMax]: "O campo deve ter no máximo {{max}} caracteres",
  [YupMessages.stringMatches]:
    "O campo deve corresponder a seguinte regra: {{regex}}",
  [YupMessages.stringEmail]: "E-mail inválido",
  [YupMessages.stringUrl]: "URL inválida",
  [YupMessages.stringTrim]:
    "O campo não deve conter espaços no início ou no fim",
  [YupMessages.stringLowerCase]: "O campo deve estar em minúsculo",
  [YupMessages.stringUpperCase]: "O campo deve estar em maiúsculo",

  [YupMessages.numberMin]: "O campo deve ser maior ou igual a {{min}}",
  [YupMessages.numberMax]: "O campo deve ser menor ou igual a {{max}}",
  [YupMessages.numberLessThan]: "O campo deve ser menor que {{less}}",
  [YupMessages.numberMoreThan]: "O campo deve ser maior que {{more}}",
  [YupMessages.numberPositive]: "O campo deve ser um número positivo",
  [YupMessages.numberNegative]: "O campo deve ser um número negativo",
  [YupMessages.numberInteger]: "O campo deve ser um número inteiro",

  [YupMessages.dateMin]: "A data deve ser à partir de {{min}}",
  [YupMessages.dateMax]: "A data deve ser anterior a {{max}}",

  [YupMessages.objectNoUnknown]:
    "O campo tem chaves não especificadas: {{unknown}}",

  [YupMessages.arrayMin]: "O campo deve ter pelo menos {{min}} itens",
  [YupMessages.arrayMax]: "O campo deve ter menos que {{max}} itens",

  [YupMessages.minutes15]: "Os minutos devem ser 00, 15, 30 ou 45",

  [YupMessages.invalidCpf]: "CPF inválido"
};
